// import React, { useState, useEffect } from "react";
// import Sidebar from "../../Components/Sidebar";
// import TopNav from "../../Components/TopNav";
// import {
//   getBannerListServ,
//   addBannerServ,
//   deleteBannerServ,
//   updateBannerServ,
// } from "../../services/banner.service";
// import Skeleton from "react-loading-skeleton";
// import "react-loading-skeleton/dist/skeleton.css";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import moment from "moment";
// import NoRecordFound from "../../Components/NoRecordFound";
// function BannerList() {
//   const [list, setList] = useState([]);
//   const [statics, setStatics] = useState(null);
//   const [payload, setPayload] = useState({
//     searchKey: "",
//     status: "",
//     pageNo: 1,
//     pageCount: 10,
//     sortByField: "",
//   });
//   const [showSkelton, setShowSkelton] = useState(false);
//   const handleGetCategoryFunc = async () => {
//     if (list.length === 0) {
//       setShowSkelton(true);
//     }
//     try {
//       let response = await getBannerListServ(payload);
//       setList(response?.data?.data);
//       setStatics(response?.data?.documentCount);
//     } catch (error) {}
//     setShowSkelton(false);
//   };
//   const staticsArr = [
//     {
//       title: "Total Banner",
//       count: statics?.totalCount,
//       bgColor: "#6777EF",
//     },
//     {
//       title: "Active Banner",
//       count: statics?.activeCount,
//       bgColor: "#63ED7A",
//     },
//     {
//       title: "Inactive Banner",
//       count: statics?.inactiveCount,
//       bgColor: "#FFA426",
//     },
//   ];
//   useEffect(() => {
//     handleGetCategoryFunc();
//   }, [payload]);
//   const [isLoading, setIsLoading] = useState(false);
//   const [addFormData, setAddFormData] = useState({
//     type: "",
//     image: "",
//     status: "",
//     show: false,
//     imgPrev: "",
//   });
//   const handleAddCategoryFunc = async () => {
//     setIsLoading(true);
//     const formData = new FormData();
//     formData?.append("type", addFormData?.type);
//     formData?.append("image", addFormData?.image);
//     formData?.append("status", addFormData?.status);
//     try {
//       let response = await addBannerServ(formData);
//       if (response?.data?.statusCode == "200") {
//         toast.success(response?.data?.message);
//         setAddFormData({
//           type: "",
//           image: "",
//           status: "",
//           show: false,
//           imgPrev: "",
//         });
//         handleGetCategoryFunc();
//       }
//     } catch (error) {
//       toast.error(
//         error?.response?.data?.message
//           ? error?.response?.data?.message
//           : "Internal Server Error"
//       );
//     }
//     setIsLoading(false);
//   };
//   const handleDeleteCategoryFunc = async (id) => {
//     const confirmed = window.confirm(
//       "Are you sure you want to delete this banner?"
//     );
//     if (confirmed) {
//       try {
//         let response = await deleteBannerServ(id);
//         if (response?.data?.statusCode == "200") {
//           toast?.success(response?.data?.message);
//           handleGetCategoryFunc();
//         }
//       } catch (error) {
//         toast.error(
//           error?.response?.data?.message
//             ? error?.response?.data?.message
//             : "Internal Server Error"
//         );
//       }
//     }
//   };
//   const [editFormData, setEditFormData] = useState({
//     type: "",
//     image: "",
//     status: "",
//     _id: "",
//     imgPrev: "",
//   });
//   const handleUpdateCategoryFunc = async () => {
//     setIsLoading(true);
//     const formData = new FormData();
//     if (editFormData?.image) {
//       formData?.append("image", editFormData?.image);
//     }
//     formData?.append("type", editFormData?.type);
//     formData?.append("status", editFormData?.status);
//     formData?.append("_id", editFormData?._id);
//     try {
//       let response = await updateBannerServ(formData);
//       if (response?.data?.statusCode == "200") {
//         toast.success(response?.data?.message);
//         setEditFormData({
//           type: "",
//           image: "",
//           status: "",
//           _id: "",
//         });
//         handleGetCategoryFunc();
//       }
//     } catch (error) {
//       toast.error(
//         error?.response?.data?.message
//           ? error?.response?.data?.message
//           : "Internal Server Error"
//       );
//     }
//     setIsLoading(false);
//   };

//   // Utility function for recommended sizes
//   const getRecommendedSizeNote = (type) => {
//     switch (type) {
//       case "Desktop":
//         return `
//   Desktop Banner Size - 1646 x 609 px
//   `;
//       case "Mobile":
//         return `
//   Mobile Banner Size - 646 x 609 px
//   `;
//       case "Brands":
//         return `
//   Brand Logo Carousel Size:
//   200 x 200 px (square) or 200 x 100 px (horizontal)
//   `;
//       case "ChitSubscriptionBanner":
//         return `
//   Chit Subscription Banner Size - 1646 x 609 px
//   `;
//       default:
//         return "";
//     }
//   };
  
//   return (
//     <div className="bodyContainer">
//       <Sidebar selectedMenu="Banners" selectedItem="Banners" />
//       <div className="mainContainer">
//         <TopNav />
//         <div className="p-lg-4 p-md-3 p-2">
//           <div
//             className="row mx-0 p-0"
//             style={{
//               position: "relative",
//               top: "-75px",
//               marginBottom: "-75px",
//             }}
//           >
//             {staticsArr?.map((v, i) => {
//               return (
//                 <div className="col-md-4 col-12 ">
//                   <div className="topCard shadow-sm py-4 px-3 rounded mb-3">
//                     <div className="d-flex align-items-center ">
//                       <div
//                         className="p-2 shadow rounded"
//                         style={{ background: v?.bgColor }}
//                       >
//                         <img src="https://cdn-icons-png.flaticon.com/128/666/666120.png" />
//                       </div>
//                       <div className="ms-3">
//                         <h6>{v?.title}</h6>
//                         <h2 className="text-secondary">{v?.count}</h2>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//           <div className="row m-0 p-0 d-flex align-items-center my-4 topActionForm">
//             <div className="col-lg-2 mb-2 col-md-12 col-12">
//               <h3 className="mb-0 text-bold text-secondary">Banners</h3>
//             </div>
//             <div className="col-lg-4 mb-2 col-md-12 col-12">
//               <div>
//                 <input
//                   className="form-control borderRadius24"
//                   placeholder="Search"
//                   onChange={(e) =>
//                     setPayload({ ...payload, searchKey: e.target.value })
//                   }
//                 />
//               </div>
//             </div>
//             <div className="col-lg-3 mb-2  col-md-6 col-12">
//               <div>
//                 <select
//                   className="form-control borderRadius24"
//                   onChange={(e) =>
//                     setPayload({ ...payload, status: e.target.value })
//                   }
//                 >
//                   <option value="">Select Status</option>
//                   <option value={true}>Active</option>
//                   <option value={false}>Inactive</option>
//                 </select>
//               </div>
//             </div>
//             <div className="col-lg-3 mb-2 col-md-6 col-12">
//               <div>
//                 <button
//                   className="btn btn-primary w-100 borderRadius24"
//                   style={{ background: "#6777EF" }}
//                   onClick={() => setAddFormData({ ...addFormData, show: true })}
//                 >
//                   Add Banner
//                 </button>
//               </div>
//             </div>
//           </div>
//           <div className="mt-3">
//             <div className="card-body px-2">
//               <div className="table-responsive table-invoice">
//                 <table className="table">
//                   <tbody>
//                     <tr style={{ background: "#F3F3F3", color: "#000" }}>
//                       <th
//                         className="text-center py-3"
//                         style={{ borderRadius: "30px 0px 0px 30px" }}
//                       >
//                         Sr. No
//                       </th>
//                       <th className="text-center py-3">Image</th>
//                       <th className="text-center py-3">Banner Type</th>
//                       <th className="text-center py-3">Status</th>
//                       <th className="text-center py-3">Created At</th>
//                       <th
//                         className="text-center py-3 "
//                         style={{ borderRadius: "0px 30px 30px 0px" }}
//                       >
//                         Action
//                       </th>
//                     </tr>
//                     <div className="py-2"></div>
//                     {showSkelton
//                       ? [1, 2, 3, 4, 5, 6, 7, 8, 9]?.map((v, i) => {
//                           return (
//                             <>
//                               <tr key={i}>
//                                 <td className="text-center">
//                                   <Skeleton width={50} height={50} />
//                                 </td>
//                                 <td className="text-center">
//                                   <Skeleton
//                                     width={50}
//                                     height={50}
//                                     borderRadius={25}
//                                   />
//                                 </td>
//                                 <td className="text-center">
//                                   <Skeleton width={100} height={25} />
//                                 </td>
//                                 <td className="text-center">
//                                   <Skeleton width={100} height={25} />
//                                 </td>
//                                 <td className="text-center">
//                                   <Skeleton width={100} height={25} />
//                                 </td>
//                                 <td className="text-center">
//                                   <Skeleton width={100} height={25} />
//                                 </td>
//                               </tr>
//                               <div className="py-2"></div>
//                             </>
//                           );
//                         })
//                       : list?.map((v, i) => {
//                           return (
//                             <>
//                               <tr>
//                                 <td className="text-center">{i + 1}</td>
//                                 <td className="text-center">
//                                   <img
//                                     src={v?.image} alt="banner"
//                                     style={{ height: "30px" }}
//                                   />
//                                 </td>
//                                 <td className="font-weight-600 text-center">
//                                   {v?.type === "Brands"
//                                     ? "Brands Logo"
//                                     : v?.type === "ChitSubscriptionBanner"
//                                     ? "Subscription Banner"
//                                     : v?.type === "Home"
//                                     ? "Home"
//                                     : v?.type}
//                                 </td>

//                                 <td className="text-center">
//                                   {v?.status ? (
//                                     <div
//                                       className="badge py-2"
//                                       style={{ background: "#63ED7A" }}
//                                     >
//                                       Active
//                                     </div>
//                                   ) : (
//                                     <div
//                                       className="badge py-2 "
//                                       style={{ background: "#FFA426" }}
//                                     >
//                                       Inactive
//                                     </div>
//                                   )}
//                                 </td>
//                                 <td className="text-center">
//                                   {moment(v?.createdAt).format("DD-MM-YY")}
//                                 </td>
//                                 <td className="text-center">
//                                   <a
//                                     onClick={() => {
//                                       setEditFormData({
//                                         type: v?.type,
//                                         image: "",
//                                         imgPrev: v?.image,
//                                         status: v?.status,
//                                         _id: v?._id,
//                                       });
//                                     }}
//                                     className="btn btn-info mx-2 text-light shadow-sm"
//                                   >
//                                     Edit
//                                   </a>
//                                   <a
//                                     onClick={() =>
//                                       handleDeleteCategoryFunc(v?._id)
//                                     }
//                                     className="btn btn-warning mx-2 text-light shadow-sm"
//                                   >
//                                     Delete
//                                   </a>
//                                 </td>
//                               </tr>
//                               <div className="py-2"></div>
//                             </>
//                           );
//                         })}
//                   </tbody>
//                 </table>
//                 {list.length == 0 && !showSkelton && <NoRecordFound />}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       {addFormData?.show && (
//         <div
//           className="modal fade show d-flex align-items-center  justify-content-center "
//           tabIndex="-1"
//         >
//           <div className="modal-dialog">
//             <div
//               className="modal-content"
//               style={{
//                 borderRadius: "16px",
//                 background: "#f7f7f5",
//                 width: "364px",
//               }}
//             >
//               <div className="d-flex justify-content-end pt-4 pb-0 px-4">
//                 <img
//                   src="https://cdn-icons-png.flaticon.com/128/9068/9068699.png"
//                   style={{ height: "20px" }}
//                   onClick={() =>
//                     setAddFormData({
//                       type: "",
//                       image: "",
//                       status: "",
//                       show: false,
//                     })
//                   }
//                 />
//               </div>

//               <div className="modal-body">
//                 <div
//                   style={{
//                     wordWrap: "break-word",
//                     whiteSpace: "pre-wrap",
//                   }}
//                   className="d-flex justify-content-center w-100"
//                 >
//                   <div className="w-100 px-2">
//                     <h5 className="mb-4">Add Banner</h5>
//                     <div className="p-3 border rounded mb-2">
//                       {addFormData?.imgPrev ? (
//                         <img
//                           src={addFormData?.imgPrev}
//                           className="img-fluid w-100 shadow rounded"
//                         />
//                       ) : (
//                         <p className="mb-0 text-center">No Item Selected !</p>
//                       )}
//                     </div>
//                     <label className="">Upload Image</label>
//                     <input
//                       className="form-control"
//                       type="file"
//                       onChange={(e) =>
//                         setAddFormData({
//                           ...addFormData,
//                           image: e.target.files[0],
//                           imgPrev: URL.createObjectURL(e.target.files[0]),
//                         })
//                       }
//                     />
//                     {/* Recommended Size Notes */}
//                     {addFormData.type && (
//                       <pre
//                         className="text-muted d-block mb-2"
//                         style={{ whiteSpace: "pre-wrap" }}
//                       >
//                         {getRecommendedSizeNote(addFormData.type)}
//                       </pre>
//                     )}

//                     <label className="mt-3">Type</label>
//                     <select
//                       className="form-control"
//                       onChange={(e) =>
//                         setAddFormData({ ...addFormData, type: e.target.value })
//                       }
//                     >
//                       <option value="">Select Type</option>
//                       <option value="Desktop">Desktop Banner</option>
//                       <option value="Mobile">Mobile Banner</option>
//                       <option value="Brands">Brands Logo</option>
//                       <option value="ChitSubscriptionBanner">
//                         Chit Subscription Banner
//                       </option>
//                     </select>

//                     <label className="mt-3">Status</label>
//                     <select
//                       className="form-control"
//                       onChange={(e) =>
//                         setAddFormData({
//                           ...addFormData,
//                           status: e.target.value,
//                         })
//                       }
//                     >
//                       <option value="">Select Status</option>
//                       <option value={true}>Active</option>
//                       <option value={false}>Inactive</option>
//                     </select>
//                     {addFormData?.type &&
//                     addFormData?.status &&
//                     addFormData?.image ? (
//                       <button
//                         className="btn btn-success w-100 mt-4"
//                         onClick={!isLoading && handleAddCategoryFunc}
//                       >
//                         {isLoading ? "Saving..." : "Submit"}
//                       </button>
//                     ) : (
//                       <button
//                         className="btn btn-success w-100 mt-4"
//                         style={{ opacity: "0.5" }}
//                       >
//                         Submit
//                       </button>
//                     )}
//                   </div>
//                 </div>
//                 <div className="d-flex justify-content-center"></div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//       {addFormData?.show && <div className="modal-backdrop fade show"></div>}
//       {editFormData?._id && (
//         <div
//           className="modal fade show d-flex align-items-center  justify-content-center "
//           tabIndex="-1"
//         >
//           <div className="modal-dialog">
//             <div
//               className="modal-content"
//               style={{
//                 borderRadius: "16px",
//                 background: "#f7f7f5",
//                 width: "364px",
//               }}
//             >
//               <div className="d-flex justify-content-end pt-4 pb-0 px-4">
//                 <img
//                   src="https://cdn-icons-png.flaticon.com/128/9068/9068699.png"
//                   style={{ height: "20px" }}
//                   onClick={() =>
//                     setEditFormData({
//                       type: "",
//                       image: "",
//                       status: "",
//                       _id: "",
//                     })
//                   }
//                 />
//               </div>

//               <div className="modal-body">
//                 <div
//                   style={{
//                     wordWrap: "break-word",
//                     whiteSpace: "pre-wrap",
//                   }}
//                   className="d-flex justify-content-center w-100"
//                 >
//                   <div className="w-100 px-2">
//                     <h5 className="mb-4">Update Banner</h5>
//                     <div className="p-3 border rounded mb-2">
//                       <img
//                         src={editFormData?.imgPrev}
//                         className="img-fluid w-100 shadow rounded"
//                       />
//                     </div>
//                     <label className="">Upload Image</label>
//                     <input
//                       className="form-control"
//                       type="file"
//                       onChange={(e) =>
//                         setEditFormData({
//                           ...editFormData,
//                           image: e.target.files[0],
//                           imgPrev: URL.createObjectURL(e.target.files[0]),
//                         })
//                       }
//                     />
//                     {/* Recommended Size Notes */}
//                     {editFormData.type && (
//                       <pre
//                         className="text-muted d-block mb-2"
//                         style={{ whiteSpace: "pre-wrap" }}
//                       >
//                         {getRecommendedSizeNote(editFormData.type)}
//                       </pre>
//                     )}

//                     <label className="mt-3">Type</label>
//                     <select
//                       className="form-control"
//                       onChange={(e) =>
//                         setEditFormData({
//                           ...editFormData,
//                           type: e.target.value,
//                         })
//                       }
//                       value={editFormData?.type}
//                     >
//                       <option value="">Select Type</option>
//                       <option value="Desktop">Desktop Banner</option>
//                       <option value="Mobile">Mobile Banner</option>
//                       <option value="Brands">Brands Logo</option>
//                       <option value="ChitSubscriptionBanner">
//                         Chit Subscription Banner
//                       </option>
//                     </select>

//                     <label className="mt-3">Status</label>
//                     <select
//                       className="form-control"
//                       onChange={(e) =>
//                         setEditFormData({
//                           ...editFormData,
//                           status: e.target.value,
//                         })
//                       }
//                       value={editFormData?.status}
//                     >
//                       <option value="">Select Status</option>
//                       <option value={true}>Active</option>
//                       <option value={false}>Inactive</option>
//                     </select>
//                     {editFormData?.type && editFormData?.status ? (
//                       <button
//                         className="btn btn-success w-100 mt-4"
//                         onClick={!isLoading && handleUpdateCategoryFunc}
//                       >
//                         {isLoading ? "Saving..." : "Submit"}
//                       </button>
//                     ) : (
//                       <button
//                         className="btn btn-success w-100 mt-4"
//                         style={{ opacity: "0.5" }}
//                       >
//                         Submit
//                       </button>
//                     )}
//                   </div>
//                 </div>
//                 <div className="d-flex justify-content-center"></div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//       {editFormData?._id && <div className="modal-backdrop fade show"></div>}
//     </div>
//   );
// }

// export default BannerList;


import React, { useState, useEffect } from "react";
import Sidebar from "../../Components/Sidebar";
import TopNav from "../../Components/TopNav";
import {
  getBannerListServ,
  addBannerServ,
  deleteBannerServ,
  updateBannerServ,
} from "../../services/banner.service";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import NoRecordFound from "../../Components/NoRecordFound";

import { IMAGE_BASE_URL } from "../../utils/api_base_url_configration";

/* ─── Scoped styles ─────────────────────────────────── */
const styles = `
  .bn-page {
    background: #f5f5f7;
    min-height: 100%;
    padding: 28px;
    font-family: 'Segoe UI', sans-serif;
  }

  /* stat grid */
  .bn-stat-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 14px;
    margin-bottom: 20px;
  }
  @media (max-width: 900px) { .bn-stat-grid { grid-template-columns: repeat(2, 1fr); } }
  @media (max-width: 560px) { .bn-stat-grid { grid-template-columns: 1fr; } }

  .bn-stat-card {
    background: #fff;
    border-radius: 14px;
    padding: 18px 20px;
    border: 1px solid #f0eded;
    display: flex;
    align-items: center;
    gap: 14px;
  }
  .bn-stat-icon {
    width: 46px; height: 46px;
    border-radius: 11px;
    display: flex; align-items: center; justify-content: center;
    font-size: 21px;
    flex-shrink: 0;
  }
  .bn-stat-val {
    font-size: 28px;
    font-weight: 700;
    color: #1c0a0a;
    line-height: 1;
  }
  .bn-stat-lbl {
    font-size: 14px;
    color: #828282;
    margin-top: 4px;
  }

  /* toolbar */
  .bn-toolbar {
    background: #fff;
    border-radius: 14px;
    padding: 16px 20px;
    border: 1px solid #f0eded;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 16px;
  }
  .bn-toolbar-title {
    font-size: 19px;
    font-weight: 700;
    color: #1c0a0a;
  }
  .bn-toolbar-right {
    display: flex; align-items: center; gap: 10px; flex-wrap: wrap;
  }
  .bn-input {
    height: 40px;
    border-radius: 10px;
    border: 1px solid #f0eded;
    padding: 0 14px;
    font-size: 14px;
    color: #555;
    background: #f9f9f9;
    outline: none;
    width: 220px;
  }
  .bn-input:focus { border-color: #f0c0b8; }
  .bn-select {
    height: 40px;
    border-radius: 10px;
    border: 1px solid #f0eded;
    padding: 0 12px;
    font-size: 14px;
    color: #555;
    background: #f9f9f9;
    outline: none;
    cursor: pointer;
  }
  .bn-select:focus { border-color: #f0c0b8; }

  .bn-btn-red {
    height: 40px;
    padding: 0 20px;
    border-radius: 10px;
    background: #a60808;
    color: #fff;
    border: none;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    display: flex; align-items: center; gap: 7px;
    white-space: nowrap;
  }
  .bn-btn-red:hover { background: #a93226; }
  .bn-btn-red i { font-size: 16px; }

  /* table */
  .bn-table-wrap {
    background: #fff;
    border-radius: 14px;
    border: 1px solid #f0eded;
    overflow: hidden;
  }
  .bn-table-scroll { overflow-x: auto; }
  .bn-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 15px;
  }
  .bn-table thead tr { background: #fdf2f1; }
  .bn-table th {
    padding: 15px 18px;
    text-align: left;
    font-size: 12px;
    font-weight: 700;
    color: #a60808;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    white-space: nowrap;
  }
  .bn-table td {
    padding: 15px 18px;
    color: #444;
    border-top: 1px solid #f7f5f5;
    vertical-align: middle;
    font-size: 15px;
  }
  .bn-table tbody tr:hover td { background: #fdfafa; }

  /* banner preview */
  .bn-img-wrap {
    width: 90px; height: 54px;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #f0eded;
    background: #f9f9f9;
    display: flex; align-items: center; justify-content: center;
  }
  .bn-img-wrap img { width: 100%; height: 100%; object-fit: cover; }

  /* type badge */
  .bn-type-badge {
    display: inline-flex; align-items: center; gap: 5px;
    padding: 5px 13px;
    border-radius: 20px;
    background: #fdf2f1;
    color: #a32d2d;
    font-size: 13px; font-weight: 600;
  }

  /* status badges */
  .bn-badge-active {
    display: inline-flex; align-items: center; gap: 5px;
    padding: 5px 13px;
    border-radius: 20px;
    background: #eaf3de; color: #27500a;
    font-size: 13px; font-weight: 600;
  }
  .bn-badge-inactive {
    display: inline-flex; align-items: center; gap: 5px;
    padding: 5px 13px;
    border-radius: 20px;
    background: #faeeda; color: #633806;
    font-size: 13px; font-weight: 600;
  }

  /* action buttons */
  .bn-edit-btn {
    height: 36px; padding: 0 16px;
    border-radius: 9px;
    border: 1px solid #f0eded;
    background: #fff;
    font-size: 14px; color: #555;
    cursor: pointer;
    display: inline-flex; align-items: center; gap: 5px;
    transition: all 0.18s;
    margin-right: 7px;
  }
  .bn-edit-btn:hover { background: #fdf2f1; border-color: #f0c0b8; color: #a60808; }
  .bn-edit-btn i { font-size: 15px; }

  .bn-del-btn {
    height: 36px; padding: 0 16px;
    border-radius: 9px;
    border: 1px solid #fcc;
    background: #fff;
    font-size: 14px; color: #a60808;
    cursor: pointer;
    display: inline-flex; align-items: center; gap: 5px;
    transition: all 0.18s;
  }
  .bn-del-btn:hover { background: #fdf2f1; }
  .bn-del-btn i { font-size: 15px; }

  /* pagination */
  .bn-pagination {
    display: flex; align-items: center;
    justify-content: flex-end;
    padding: 16px 20px;
    border-top: 1px solid #f7f5f5;
  }
  .bn-pg-btns { display: flex; align-items: center; gap: 5px; }
  .bn-pg-btn {
    width: 36px; height: 36px;
    border-radius: 9px;
    border: 1px solid #f0eded;
    background: #fff;
    font-size: 14px; color: #555;
    cursor: pointer;
    display: flex; align-items: center; justify-content: center;
    transition: all 0.18s;
  }
  .bn-pg-btn.active { background: #a60808; color: #fff; border-color: #a60808; }
  .bn-pg-btn:hover:not(.active):not([disabled]) { background: #fdf2f1; color: #a60808; }
  .bn-pg-btn:disabled { opacity: 0.4; cursor: default; }

  /* modal overlay */
  .bn-modal-overlay {
    position: fixed; inset: 0;
    background: rgba(0,0,0,0.45);
    display: flex; align-items: center; justify-content: center;
    z-index: 1050;
  }
  .bn-modal {
    background: #fff;
    border-radius: 18px;
    width: 100%; max-width: 460px;
    max-height: 88vh; overflow-y: auto;
    box-shadow: 0 16px 48px rgba(0,0,0,0.14);
  }
  .bn-modal-header {
    display: flex; align-items: center;
    justify-content: space-between;
    padding: 22px 26px 16px;
    border-bottom: 1px solid #f0eded;
  }
  .bn-modal-title { font-size: 17px; font-weight: 700; color: #1c0a0a; }
  .bn-modal-close {
    width: 34px; height: 34px;
    border-radius: 9px;
    border: 1px solid #f0eded;
    background: none; cursor: pointer;
    display: flex; align-items: center; justify-content: center;
    color: #888; font-size: 17px;
  }
  .bn-modal-close:hover { background: #fdf2f1; color: #a60808; }
  .bn-modal-body { padding: 22px 26px; }

  /* form fields inside modal */
  .bn-form-label {
    display: block;
    font-size: 13px; font-weight: 600;
    color: #888;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 7px;
    margin-top: 18px;
  }
  .bn-form-label:first-child { margin-top: 0; }
  .bn-form-control {
    width: 100%;
    height: 42px;
    border-radius: 10px;
    border: 1px solid #f0eded;
    padding: 0 14px;
    font-size: 14px; color: #444;
    background: #f9f9f9;
    outline: none;
    box-sizing: border-box;
  }
  .bn-form-control:focus { border-color: #f0c0b8; }
  .bn-file-input {
    width: 100%;
    border-radius: 10px;
    border: 1px solid #f0eded;
    padding: 8px 14px;
    font-size: 14px; color: #444;
    background: #f9f9f9;
    outline: none;
    box-sizing: border-box;
  }

  .bn-img-preview {
    width: 100%; height: 160px;
    border-radius: 12px;
    border: 1px dashed #f0c0b8;
    background: #fdf2f1;
    display: flex; align-items: center; justify-content: center;
    overflow: hidden;
    margin-bottom: 18px;
  }
  .bn-img-preview img { width: 100%; height: 100%; object-fit: cover; }
  .bn-img-preview-empty { font-size: 14px; color: #ccc; }

  .bn-size-note {
    background: #fdf2f1;
    border-left: 3px solid #a60808;
    border-radius: 0 8px 8px 0;
    padding: 10px 14px;
    font-size: 13px; color: #a32d2d;
    margin-top: 10px;
    white-space: pre-wrap;
    line-height: 1.7;
  }

  .bn-submit-btn {
    width: 100%;
    height: 44px;
    border-radius: 10px;
    background: #a60808;
    color: #fff;
    border: none;
    font-size: 15px; font-weight: 600;
    cursor: pointer;
    margin-top: 22px;
    transition: background 0.18s;
  }
  .bn-submit-btn:hover:not(:disabled) { background: #a93226; }
  .bn-submit-btn:disabled { opacity: 0.5; cursor: default; }

  .bn-modal-footer {
    padding: 16px 26px;
    border-top: 1px solid #f0eded;
    display: flex; justify-content: flex-end;
  }
`;

const TYPE_LABELS = {
  Desktop: "Desktop Banner",
  Mobile: "Mobile Banner",
  Brands: "Brands Logo",
  ChitSubscriptionBanner: "Subscription Banner",
  Home: "Home",
};

const getRecommendedSizeNote = (type) => {
  switch (type) {
    case "Desktop":            return "Recommended size: 1646 × 609 px";
    case "Mobile":             return "Recommended size: 646 × 609 px";
    case "Brands":             return "Recommended size: 200 × 200 px (square)  or  200 × 100 px (horizontal)";
    case "ChitSubscriptionBanner": return "Recommended size: 1646 × 609 px";
    default:                   return "";
  }
};

function ChitBannerList() {

   const getImageUrl = (image) => {
     if (!image) return "";
   
     // Already full URL (Cloudinary etc.)
     if (image.startsWith("http")) return image;
   
     // Local uploads
     return `${IMAGE_BASE_URL}${image}`;
   };

   const getPreviewImage = (img) => {
  if (!img) return "";

  // New selected image
  if (img.startsWith("blob:")) return img;

  // Existing image from backend
  return getImageUrl(img);
};


  const [list, setList] = useState([]);
  const [statics, setStatics] = useState(null);
  const [payload, setPayload] = useState({
    searchKey: "",
    status: "",
    pageNo: 1,
    pageCount: 10,
    sortByField: "",
    type: "ChitSubscriptionBanner",
  });
  const [showSkelton, setShowSkelton] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(1);

  const [addFormData, setAddFormData] = useState({
    type: "ChitSubscriptionBanner", image: "", status: "", show: false, imgPrev: "",
  });
  const [editFormData, setEditFormData] = useState({
    type: "ChitSubscriptionBanner", image: "", status: "", _id: "", imgPrev: "",
  });

  const handleGetBanners = async () => {
    if (list.length === 0) setShowSkelton(true);
    try {
      let response = await getBannerListServ(payload);
      setList(response?.data?.data);
      setStatics(response?.data?.documentCount);
    } catch (error) {}
    setShowSkelton(false);
  };

  useEffect(() => { handleGetBanners(); }, [payload]);

  useEffect(() => {
    if (statics?.totalCount && payload.pageCount) {
      setTotalPages(Math.ceil(statics.totalCount / payload.pageCount));
    }
  }, [statics, payload.pageCount]);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages)
      setPayload({ ...payload, pageNo: newPage });
  };

  const handleAdd = async () => {
    setIsLoading(true);
    const formData = new FormData();
    formData.append("type", addFormData.type);
    formData.append("image", addFormData.image);
    formData.append("status", addFormData.status);
    try {
      let response = await addBannerServ(formData);
      if (response?.data?.statusCode == "200") {
        toast.success(response?.data?.message);
        setAddFormData({ type: "ChitSubscriptionBanner", image: "", status: "", show: false, imgPrev: "" });
        handleGetBanners();
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Internal Server Error");
    }
    setIsLoading(false);
  };

  const handleUpdate = async () => {
    setIsLoading(true);
    const formData = new FormData();
    if (editFormData.image) formData.append("image", editFormData.image);
    formData.append("type", editFormData.type);
    formData.append("status", editFormData.status);
    formData.append("_id", editFormData._id);
    try {
      let response = await updateBannerServ(formData);
      if (response?.data?.statusCode == "200") {
        toast.success(response?.data?.message);
        setEditFormData({ type: "ChitSubscriptionBanner", image: "", status: "", _id: "", imgPrev: "" });
        handleGetBanners();
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Internal Server Error");
    }
    setIsLoading(false);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this banner?")) return;
    try {
      let response = await deleteBannerServ(id);
      if (response?.data?.statusCode == "200") {
        toast.success(response?.data?.message);
        handleGetBanners();
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Internal Server Error");
    }
  };

  /* ── shared modal form ── */
  const BannerForm = ({ data, setData, onSubmit, title }) => (
    <div className="bn-modal-overlay">
      <div className="bn-modal">
        <div className="bn-modal-header">
          <div className="bn-modal-title">{title}</div>
          <button
            className="bn-modal-close"
            onClick={() =>
              title === "Add banner"
                ? setAddFormData({ type: "ChitSubscriptionBanner", image: "", status: "", show: false, imgPrev: "" })
                : setEditFormData({ type: "ChitSubscriptionBanner", image: "", status: "", _id: "", imgPrev: "" })
            }
          >
            <i className="ti ti-x" aria-hidden="true" />
          </button>
        </div>
        <div className="bn-modal-body">
          {/* preview */}
          <div className="bn-img-preview">
            {data.imgPrev
               ? <img src={getPreviewImage(data.imgPrev)} alt="preview" />
              : <span className="bn-img-preview-empty">
                  <i className="ti ti-photo" style={{ fontSize: 32, color: "#f0c0b8" }} aria-hidden="true" />
                </span>
            }
          </div>

          {/* upload */}
          <label className="bn-form-label">Upload image</label>
          <input
            className="bn-file-input"
            type="file"
            accept="image/*"
            onChange={(e) =>
              setData({
                ...data,
                image: e.target.files[0],
                imgPrev: URL.createObjectURL(e.target.files[0]),
              })
            }
          />

          {/* type */}
          <label className="bn-form-label">Banner type</label>
          <input
            className="bn-form-control"
            value="Subscription Banner"
            readOnly
            disabled
          />

          {/* size note */}
          {data.type && (
            <div className="bn-size-note">
              <i className="ti ti-info-circle" aria-hidden="true" style={{ marginRight: 6 }} />
              {getRecommendedSizeNote(data.type)}
            </div>
          )}

          {/* status */}
          <label className="bn-form-label">Status</label>
          <select
            className="bn-form-control"
            value={data.status}
            onChange={(e) => setData({ ...data, status: e.target.value })}
          >
            <option value="">Select status</option>
            <option value={true}>Active</option>
            <option value={false}>Inactive</option>
          </select>

          <button
            className="bn-submit-btn"
            onClick={onSubmit}
            disabled={
              isLoading ||
              !data.type ||
              !data.status ||
              (title === "Add banner" && !data.image)
            }
          >
            {isLoading ? "Saving..." : "Submit"}
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <div className="bodyContainer">
      <style>{styles}</style>
      <Sidebar selectedMenu="Banners" selectedItem="Banners" />
      <div className="mainContainer">
        <TopNav pageTitle="Banners" pagePath="Home / Banners" />
        <div className="bn-page">

          {/* ── Stat Cards ── */}
          <div className="bn-stat-grid">
            <div className="bn-stat-card">
              <div className="bn-stat-icon" style={{ background: "#fdf2f1", color: "#a32d2d" }}>
                <i className="ti ti-layout-dashboard" aria-hidden="true" />
              </div>
              <div>
                <div className="bn-stat-val">{statics?.totalCount ?? "—"}</div>
                <div className="bn-stat-lbl">Total banners</div>
              </div>
            </div>
            <div className="bn-stat-card">
              <div className="bn-stat-icon" style={{ background: "#eaf3de", color: "#3b6d11" }}>
                <i className="ti ti-circle-check" aria-hidden="true" />
              </div>
              <div>
                <div className="bn-stat-val">{statics?.activeCount ?? "—"}</div>
                <div className="bn-stat-lbl">Active banners</div>
              </div>
            </div>
            <div className="bn-stat-card">
              <div className="bn-stat-icon" style={{ background: "#faeeda", color: "#854f0b" }}>
                <i className="ti ti-circle-x" aria-hidden="true" />
              </div>
              <div>
                <div className="bn-stat-val">{statics?.inactiveCount ?? "—"}</div>
                <div className="bn-stat-lbl">Inactive banners</div>
              </div>
            </div>
          </div>

          {/* ── Toolbar ── */}
          <div className="bn-toolbar">
            <div className="bn-toolbar-title">Banners</div>
            <div className="bn-toolbar-right">
              <input
                className="bn-input"
                placeholder="Search banners..."
                onChange={(e) =>
                  setPayload({ ...payload, searchKey: e.target.value, pageNo: 1 })
                }
              />
              <select
                className="bn-select"
                onChange={(e) =>
                  setPayload({ ...payload, status: e.target.value, pageNo: 1 })
                }
              >
                <option value="">All status</option>
                <option value={true}>Active</option>
                <option value={false}>Inactive</option>
              </select>
              <button
                className="bn-btn-red"
                onClick={() => setAddFormData({ ...addFormData, show: true })}
              >
                <i className="ti ti-plus" aria-hidden="true" />
                Add banner
              </button>
            </div>
          </div>

          {/* ── Table ── */}
          <div className="bn-table-wrap">
            <div className="bn-table-scroll">
              <table className="bn-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Preview</th>
                    <th>Banner type</th>
                    <th>Status</th>
                    <th>Created at</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {showSkelton ? (
                    [...Array(8)].map((_, i) => (
                      <tr key={i}>
                        {[...Array(6)].map((__, j) => (
                          <td key={j} style={{ padding: "15px 18px", borderTop: "1px solid #f7f5f5" }}>
                            <Skeleton height={20} />
                          </td>
                        ))}
                      </tr>
                    ))
                  ) : list?.length === 0 ? (
                    <tr>
                      <td colSpan="6" style={{ textAlign: "center", padding: "48px" }}>
                        <NoRecordFound />
                      </td>
                    </tr>
                  ) : (
                    list.map((v, i) => (
                      <tr key={v?._id}>
                        <td style={{ color: "#828282", fontSize: "14px" }}>
                          {(payload.pageNo - 1) * payload.pageCount + i + 1}
                        </td>
                        <td>
                          <div className="bn-img-wrap">
                             <img src={getImageUrl(v?.image)} alt="banner" />
                          </div>
                        </td>
                        <td>
                          <span className="bn-type-badge">
                            <i className="ti ti-photo" aria-hidden="true" style={{ fontSize: 13 }} />
                            {TYPE_LABELS[v?.type] || v?.type}
                          </span>
                        </td>
                        <td>
                          {v?.status
                            ? <span className="bn-badge-active">
                                <i className="ti ti-circle-check" style={{ fontSize: 13 }} aria-hidden="true" /> Active
                              </span>
                            : <span className="bn-badge-inactive">
                                <i className="ti ti-circle-x" style={{ fontSize: 13 }} aria-hidden="true" /> Inactive
                              </span>
                          }
                        </td>
                        <td style={{ color: "#888", fontSize: "14px" }}>
                          {moment(v?.createdAt).format("DD MMM YYYY")}
                        </td>
                        <td>
                          <button
                            className="bn-edit-btn"
                            onClick={() =>
                              setEditFormData({
                                type: v?.type,
                                image: "",
                                imgPrev: v?.image,
                                status: v?.status,
                                _id: v?._id,
                              })
                            }
                          >
                            <i className="ti ti-edit" aria-hidden="true" /> Edit
                          </button>
                          <button
                            className="bn-del-btn"
                            onClick={() => handleDelete(v?._id)}
                          >
                            <i className="ti ti-trash" aria-hidden="true" /> Delete
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            <div className="bn-pagination">
              <div className="bn-pg-btns">
                <button
                  className="bn-pg-btn"
                  disabled={payload.pageNo === 1}
                  onClick={() => handlePageChange(payload.pageNo - 1)}
                >
                  <i className="ti ti-chevron-left" style={{ fontSize: "14px" }} />
                </button>
                {[...Array(totalPages)].map((_, i) => {
                  const page = i + 1;
                  if (
                    page === 1 || page === totalPages ||
                    (page >= payload.pageNo - 1 && page <= payload.pageNo + 1)
                  ) {
                    return (
                      <button
                        key={page}
                        className={`bn-pg-btn ${payload.pageNo === page ? "active" : ""}`}
                        onClick={() => handlePageChange(page)}
                      >
                        {page}
                      </button>
                    );
                  } else if (
                    (page === payload.pageNo - 2 && page > 2) ||
                    (page === payload.pageNo + 2 && page < totalPages - 1)
                  ) {
                    return <button key={page} className="bn-pg-btn" disabled>...</button>;
                  }
                  return null;
                })}
                <button
                  className="bn-pg-btn"
                  disabled={payload.pageNo === totalPages}
                  onClick={() => handlePageChange(payload.pageNo + 1)}
                >
                  <i className="ti ti-chevron-right" style={{ fontSize: "14px" }} />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ── Add Modal ── */}
      {addFormData?.show && (
        <BannerForm
          data={addFormData}
          setData={setAddFormData}
          onSubmit={handleAdd}
          title="Add banner"
        />
      )}

      {/* ── Edit Modal ── */}
      {editFormData?._id && (
        <BannerForm
          data={editFormData}
          setData={setEditFormData}
          onSubmit={handleUpdate}
          title="Edit banner"
        />
      )}
    </div>
  );
}

export default ChitBannerList;